import type { Filter, FiltersByOutcomeParameterMap } from '../types';

export const getNonNumericFilters = (
    filtersMap: FiltersByOutcomeParameterMap,
): Filter[] => {
    const nonNumericFilters: Filter[] = [];

    for (const [, filter] of filtersMap) {
        if (filter.kind === 'NUMERIC_PARAM_VALUE') {
            continue;
        }

        nonNumericFilters.push(filter);
    }

    return nonNumericFilters;
}
